import { OwardLinkButton } from "@components/Core";
import styles from './ProfilePersoPage.module.scss';
import { useTranslate } from "@hooks/use-translate";
import Link from "next/link";
import React from "react";

interface ProfilePersoPageNotFoundProps {
  errorMsgKey: string;
}

export const ProfilePersoPageNotFound: React.FC<ProfilePersoPageNotFoundProps> = props => {
  const { t, locale } = useTranslate();

  return (
    <React.Fragment>
      <section className={`hero is-fullheight-with-navbar is-unselectable`}>
        <div className='hero-body'>
          <div className='container is-fluid has-text-centered'>
            <p className={'has-text-black is-size-4 has-text-weight-light'}>
              {t(props.errorMsgKey)}
              <br />
              <br />
              <span className='icon is-large'>
                <i className={'fas fa-3x fa-times'}></i>
              </span>
              <br />
              <br />
            </p>
            <div className={styles.goGalleryButtonContainer} >
              <Link href="/">
                <OwardLinkButton
                  name={t('page.profile.return_gallery')}
                />
              </Link>
            </div>
          </div>
        </div >
      </section>
    </React.Fragment >
  );
}
